export default "__VITE_ASSET__CKeHQFD1__"